import { VerifyCardType } from "@app/enums";

export const cardTypeOptions = [
  { label: "Driver license", value: VerifyCardType.DRIVER_LICENSE },
  { value: VerifyCardType.IDENTIFY_CARD, label: "Identify Card" },
];
